import { gql } from '@apollo/client'
import { useMutation } from 'src/services/apollo'
import { IUseMutationOptions } from 'src/services/apollo/Mutation/useMutation'
import {
  QualificationInstanceAttachmentDelete,
  QualificationInstanceAttachmentDeleteVariables,
} from './__gql__/qualificationInstanceAttachmentDeleteCodeGen'

const QUALIFICATION_INSTANCE_ATTACHMENT_DELETE = gql`
  mutation QualificationInstanceAttachmentDelete($id: ID!) {
    qualificationInstanceAttachmentDelete(id: $id) {
      documentId
    }
  }
`

const useQualificationInstanceAttachmentDelete = (
  options?: IUseMutationOptions<QualificationInstanceAttachmentDelete, QualificationInstanceAttachmentDeleteVariables>,
) => {
  return useMutation<QualificationInstanceAttachmentDelete, QualificationInstanceAttachmentDeleteVariables>(
    QUALIFICATION_INSTANCE_ATTACHMENT_DELETE,
    {
      ...options,
    },
  )
}

export { useQualificationInstanceAttachmentDelete, QUALIFICATION_INSTANCE_ATTACHMENT_DELETE }
